import { get } from 'lodash';
import { getExperienceOffers } from '@origin-digital/features';

import * as REGIONS from '../consts/regions';
import { COMPARE_PLANS_PATH } from '../consts/config';

export const getExperienceOffer = (mbox) => get(getExperienceOffers(mbox), '[0]');

export const regionsList = Object.values(REGIONS);

export const DEFAULTS = {
  region: REGIONS.VIC,
};

export function getUserPostcodeValue(userLocationObject) {
  let newPostcode = DEFAULTS.region.defaultPostcode;

  if (userLocationObject) {
    if (Array.isArray(userLocationObject.subdivisions)) {
      const matchingRegion = regionsList.find(
        (region) => region.id === userLocationObject.subdivisions[0].iso_code,
      );
      // only using the post code if the geolocation returned a valid region,
      // otherwise the post code can be some weird value depending on the country!
      if (
        matchingRegion &&
        userLocationObject.postal &&
        userLocationObject.postal.code &&
        userLocationObject.postal.code !== '1001'
      ) {
        newPostcode = userLocationObject.postal.code || newPostcode;
      }
    }
  }

  return { postcode: newPostcode };
}

// very loose UserAgent device checking to serve single App Store link
export const isAppleMobile = (userAgent) => {
  return /\b(iPad|iPhone)\b/i.test(userAgent);
};

export const isAndroid = (userAgent) => {
  return /\b(Android)\b/i.test(userAgent);
};

export const getComparePlanPath = (postcode: string) => {
  return `${COMPARE_PLANS_PATH}${postcode}`;
};
